
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { comparePrimitives, equals, int32ToString, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { map as map_2, empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { SignatureDialog } from "../../../Components/SignatureDialog.js";
import { find, length, exists, choose, indexed, empty as empty_1, tryHead, isEmpty, tryFind, map, mapIndexed, ofArray, singleton as singleton_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ProcedureTemplateStepId, FormState_$ctor_240AE3F4, PropertyConfigurationId__get_unwrap, FormState__getValidation, FormState_get_empty } from "../../../Shared/Shared.js";
import { Button, TextButton } from "../../../Components/Button.js";
import { TextValue, PageHeader } from "../../../Components/Text.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import Arrow_Left_1 from "../../../../public/assets/icons/Arrow_Left_1.svg";
import { FileType, Msg } from "./Types.js";
import File_Report from "../../../../public/assets/icons/File_Report.svg";
import { Input, NumberInput } from "../../../Components/Input.js";
import { unwrap, defaultArg, bind, map as map_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { RadioButton } from "../../../Components/RadioButton.js";
import { DatePicker } from "../../../Components/DatePicker.js";
import { ProcedureStepElementResultValue__ResultToString, ProcedureReminderCompletionEntry, ProcedureTemplateStepElementType } from "../../../Shared/Procedure.js";
import { MultiSelect, Select } from "../../../Components/Select.js";
import { TextArea } from "../../../Components/TextArea.js";
import { rangeDouble } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { CustomProperty, PropertyConfiguration } from "../../../Shared/PropertyConfiguration.js";
import { containsKey, toList as toList_1, ofList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { StringProperty, MultiEnumProperty, EnumProperty, CurrencyProperty, DateProperty, BoolProperty, TextAreaProperty } from "../../CustomProperties.js";
import { ToolState__ToI18nString, ToolState_TryParse_Z721C83C5 } from "../../../Shared/Tool.js";
import { unwrapStorageId } from "../../../Shared/Helper.js";
import { parse, toLocalTime, toString } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { toISOString } from "../../../Common.js";
import { toString as toString_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { parse as parse_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import Check_Circle from "../../../../public/assets/icons/Check_Circle.svg";
import { InformationAlert } from "../../../Components/Alert.js";
import { contains, ofList as ofList_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { ConfirmationDialogWithClasses } from "../../../Components/Dialog.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";

function SignatureInput(props) {
    let elems;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(false);
    const setIsSignatureDialogOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = toList(delay(() => append(singleton(createElement(SignatureDialog, {
        Classes: singleton_1("z-[1100]"),
        Description: props.Label,
        FormState: FormState_get_empty(),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsSignatureDialogOpen(false);
        },
        OnConfirm: (file) => {
            props.OnSetSignature(file);
            setIsSignatureDialogOpen(false);
        },
    })), delay(() => append(singleton(reactElement("label", {
        className: join(" ", ["text-sm", "font-bold"]),
        children: props.Label,
    })), delay(() => {
        let matchValue, signature, imageUrl;
        return append((matchValue = props.SignatureFile, (matchValue == null) ? (empty()) : ((signature = matchValue, (imageUrl = URL.createObjectURL(signature), singleton(reactElement("img", {
            className: join(" ", ["h-24", "border", "rounded"]),
            src: imageUrl,
        })))))), delay(() => append(singleton(createElement(TextButton, {
            ComponentState: props.ComponentState,
            Label: patternInput[0]("notification.sign"),
            OnClick: () => {
                setIsSignatureDialogOpen(true);
            },
            TestId: "",
            Variant: "blueButton",
        })), delay(() => {
            const matchValue_1 = props.ValidationMessage;
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                const message = matchValue_1;
                return singleton(reactElement("p", {
                    className: join(" ", ["mt-1", "text-red", "text-sm"]),
                    children: message,
                }));
            }
        }))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function DescriptionContent(props) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(PageHeader, {
        Text: props.Dto.Title,
    }), createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: props.Dto.Description,
    }), createElement(Button, {
        ComponentState: props.ComponentState,
        Label: patternInput[0]("general.start"),
        OnClick: props.OnStart,
        TestId: "",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function StepButtonsContent(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-5"])], (elems = toList(delay(() => append(singleton(createElement(Button, {
        ComponentState: props.ComponentState,
        Label: t("general.back"),
        OnClick: props.OnBack,
        TestId: "",
        Variant: "secondary",
    })), delay(() => append(!props.IsLastStep ? singleton(createElement(Button, {
        ComponentState: props.ComponentState,
        Label: t("general.next"),
        OnClick: props.OnNext,
        TestId: "",
        Variant: "primary",
    })) : empty(), delay(() => (props.IsLastStep ? singleton(createElement(Button, {
        ComponentState: props.ComponentState,
        Label: t("general.save"),
        OnClick: props.OnSave,
        TestId: "",
        Variant: "primary",
    })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function StepIndicator(props) {
    let elems_1;
    const matchValue = props.CurrentStepIndex;
    if (matchValue == null) {
        return defaultOf();
    }
    else {
        const currentIndex = matchValue | 0;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "space-x-4"])], (elems_1 = mapIndexed((index, step) => {
            let elems;
            const isCurrentIndex = index === currentIndex;
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "cursor-pointer"])], (elems = [reactElement("div", {
                onClick: (_arg) => {
                    props.OnClick(index);
                },
                className: join(" ", toList(delay(() => append(singleton("w-10"), delay(() => append(singleton("h-10"), delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("rounded-full"), delay(() => append(singleton("border-2"), delay(() => append(singleton("border-gray-400"), delay(() => append(singleton("text-gray-400"), delay(() => (isCurrentIndex ? singleton("text-primary") : empty())))))))))))))))))))))),
                children: int32ToString(index + 1),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, props.Steps), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
}

function ProcedureFormStep(props) {
    return reactElement("div", {
        children: ["todo"],
    });
}

function ProcedureStepForm(props) {
    let elems_28, elems, Label, elems_27, elems_2, elems_1, elems_25, elems_26;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "shadow"])], (elems_28 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mt-5", "ml-5"])], (elems = [createElement(TextButton, (Label = t("procedure.back"), {
        ComponentState: "enabled",
        Icon: Arrow_Left_1(),
        Label: Label,
        OnClick: () => {
            props.Dispatch(new Msg(28, [undefined]));
        },
        TestId: "back",
        Variant: "blueButton",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5", "ml-20", "mt-6", "mb-11", "max-w-[30rem]"])], (elems_27 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[2rem_1fr]"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["row-start-1", "col-start-1", "h-4", "w-4", "self-center"])], (elems_1 = [File_Report()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", {
        className: join(" ", ["row-start-1", "col-start-2"]),
        children: props.ProcedureTemplateStep.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3.5"])], (elems_25 = toList(delay(() => map((procedureTemplateStepElement) => {
        let Value_1, Value_2, elems_3, Value_3, elems_5, elems_6, Options, Value_4, Options_1, Value_5, elems_13, Options_2, Value_6, elems_12, matchValue_5, elems_14, elems_15, Label_20, Value_9, elems_18, elems_24, Value;
        const currentResult = tryFind((result) => (result.ProcedureTemplateStepElementId === procedureTemplateStepElement.Id), props.WriteProcedureStepDto.Results);
        const matchValue = procedureTemplateStepElement.Type;
        switch (matchValue.tag) {
            case 2:
                return createElement(NumberInput, (Value_1 = map_1((value_14) => value_14, bind((_arg_2) => _arg_2.IntNumberValue, currentResult)), {
                    ComponentState: componentState,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_15) => {
                        props.Dispatch(new Msg(1, [procedureTemplateStepElement.Id, defaultArg(map_1((value_16) => (~~value_16 | 0), value_15), 0)]));
                    },
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: unwrap(Value_1),
                }));
            case 3:
                return createElement(NumberInput, (Value_2 = bind((_arg_3) => _arg_3.FloatNumberValue, currentResult), {
                    ComponentState: componentState,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_18) => {
                        props.Dispatch(new Msg(2, [procedureTemplateStepElement.Id, value_18]));
                    },
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: unwrap(Value_2),
                }));
            case 4: {
                const currentBoolValue = bind((_arg_4) => _arg_4.BoolValue, currentResult);
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_3 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => append(singleton(RadioButton({
                    ComponentState: componentState,
                    Label: t("general.yes"),
                    OnSelect: (_arg_5) => {
                        props.Dispatch(new Msg(3, [procedureTemplateStepElement.Id, true]));
                    },
                    Selected: equals(currentBoolValue, true),
                })), delay(() => append(singleton(RadioButton({
                    ComponentState: componentState,
                    Label: t("general.no"),
                    OnSelect: (_arg_6) => {
                        props.Dispatch(new Msg(3, [procedureTemplateStepElement.Id, false]));
                    },
                    Selected: equals(currentBoolValue, false),
                })), delay(() => {
                    const matchValue_1 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id);
                    if (matchValue_1 == null) {
                        return empty();
                    }
                    else {
                        const msg = matchValue_1;
                        return singleton(reactElement("p", {
                            className: join(" ", ["mt-1", "text-red", "text-sm"]),
                            children: msg,
                        }));
                    }
                })))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
            }
            case 5:
                return createElement(DatePicker, (Value_3 = bind((_arg_7) => _arg_7.DateTimeValue, currentResult), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_27) => {
                        props.Dispatch(new Msg(6, [procedureTemplateStepElement.Id, value_27]));
                    },
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: unwrap(Value_3),
                }));
            case 1:
                return reactElement("div", {
                    className: join(" ", ["p-3", "bg-gray-100", "rounded", "whitespace-pre-wrap", "break-words"]),
                    children: procedureTemplateStepElement.Label,
                });
            case 11:
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_5 = toList(delay(() => append((procedureTemplateStepElement.Label !== "") ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })) : empty(), delay(() => {
                    let elems_4;
                    return !isEmpty(procedureTemplateStepElement.Options) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems_4 = toList(delay(() => map((imageUrl) => reactElement("img", {
                        className: join(" ", ["rounded", "border", "max-w-full", "max-h-48", "object-contain"]),
                        src: imageUrl,
                    }), procedureTemplateStepElement.Options))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty();
                })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
            case 6:
                return reactElement("div", {
                    className: join(" ", ["p-3", "bg-gray-100", "rounded"]),
                    children: procedureTemplateStepElement.Label,
                });
            case 7:
                return createElement(SignatureInput, {
                    ComponentState: componentState,
                    ElementId: procedureTemplateStepElement.Id,
                    Label: procedureTemplateStepElement.Label,
                    OnSetSignature: (file) => {
                        props.Dispatch(new Msg(26, [procedureTemplateStepElement.Id, file, new FileType(0, [])]));
                    },
                    SignatureFile: unwrap(bind((sf_1) => tryHead(sf_1.Files), tryFind((sf) => {
                        if (sf.StepId === procedureTemplateStepElement.Id) {
                            return equals(sf.Type, new FileType(0, []));
                        }
                        else {
                            return false;
                        }
                    }, props.StepFiles))),
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                });
            case 10: {
                const currentSelectValue = bind((_arg_8) => _arg_8.SingleSelectValue, currentResult);
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_6 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => append(map((opt) => RadioButton({
                    ComponentState: componentState,
                    Label: opt,
                    OnSelect: (_arg_9) => {
                        props.Dispatch(new Msg(4, [procedureTemplateStepElement.Id, {
                            label: opt,
                            value: opt,
                        }, new ProcedureTemplateStepElementType(10, [])]));
                    },
                    Selected: equals(currentSelectValue, opt),
                }), procedureTemplateStepElement.Options), delay(() => {
                    const matchValue_2 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id);
                    if (matchValue_2 == null) {
                        return empty();
                    }
                    else {
                        const msg_1 = matchValue_2;
                        return singleton(reactElement("p", {
                            className: join(" ", ["mt-1", "text-red", "text-sm"]),
                            children: msg_1,
                        }));
                    }
                })))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
            }
            case 8: {
                const currentSelectValue_1 = bind((_arg_10) => _arg_10.SingleSelectValue, currentResult);
                return createElement(Select, (Options = map((opt_1) => ({
                    label: opt_1,
                    value: opt_1,
                }), procedureTemplateStepElement.Options), (Value_4 = map_1((v) => ({
                    label: v,
                    value: v,
                }), currentSelectValue_1), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: procedureTemplateStepElement.Label,
                    NoOptionsMessage: "",
                    OnChange: (value_52) => {
                        props.Dispatch(new Msg(4, [procedureTemplateStepElement.Id, value_52, new ProcedureTemplateStepElementType(8, [])]));
                    },
                    Options: Options,
                    PlaceholderKey: "general.select",
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: unwrap(Value_4),
                })));
            }
            case 9: {
                const currentMultiValues = defaultArg(bind((_arg_11) => _arg_11.MultiSelectValue, currentResult), empty_1());
                return createElement(MultiSelect, (Options_1 = map((opt_2) => ({
                    label: opt_2,
                    value: opt_2,
                }), procedureTemplateStepElement.Options), (Value_5 = map((v_1) => ({
                    label: v_1,
                    value: v_1,
                }), currentMultiValues), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: procedureTemplateStepElement.Label,
                    NoOptionsMessage: "",
                    OnChange: (value_54) => {
                        props.Dispatch(new Msg(5, [procedureTemplateStepElement.Id, value_54]));
                    },
                    Options: Options_1,
                    PlaceholderKey: "general.select",
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: Value_5,
                })));
            }
            case 12: {
                const currentInspectionResultValue = bind((_arg_12) => _arg_12.InspectionResultValue, currentResult);
                const currentComment = defaultArg(bind((_arg_13) => _arg_13.InspectionResultComment, currentResult), "");
                const elementDocuments = defaultArg(map_1((_arg_14) => _arg_14.Files, tryFind((entry) => (entry.ElementId === procedureTemplateStepElement.Id), props.InspectionDocuments)), empty_1());
                const fileUploadId = concat("inspection-doc-upload-", ...procedureTemplateStepElement.Id);
                let inspectionLabel;
                const matchValue_3 = procedureTemplateStepElement.InspectionTemplateName;
                inspectionLabel = ((matchValue_3 == null) ? procedureTemplateStepElement.Label : concat(procedureTemplateStepElement.Label, " (", matchValue_3, ...")"));
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_13 = [createElement(Select, (Options_2 = map((opt_3) => ({
                    label: opt_3,
                    value: opt_3,
                }), procedureTemplateStepElement.Options), (Value_6 = map_1((v_2) => ({
                    label: v_2,
                    value: v_2,
                }), currentInspectionResultValue), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: inspectionLabel,
                    NoOptionsMessage: "",
                    OnChange: (value_58) => {
                        props.Dispatch(new Msg(7, [procedureTemplateStepElement.Id, value_58]));
                    },
                    Options: Options_2,
                    PlaceholderKey: "general.select",
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: unwrap(Value_6),
                }))), createElement(TextArea, {
                    ComponentState: componentState,
                    Label: t("inspection_result.comment"),
                    OnChange: (value_59) => {
                        props.Dispatch(new Msg(8, [procedureTemplateStepElement.Id, value_59]));
                    },
                    TestId: "",
                    Value: currentComment,
                }), reactElement("div", createObj(singleton_1((elems_12 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold", "mb-2", "block"]),
                    children: t("inspection_result.document_upload"),
                })), delay(() => {
                    let elems_7;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "justify-center", "items-center", "rounded-lg", "border", "border-dashed", "border-primary", "p-4"])], ["onDragOver", (e) => {
                        e.preventDefault();
                    }], ["onDrop", (e_1) => {
                        e_1.preventDefault();
                        props.Dispatch(new Msg(16, [procedureTemplateStepElement.Id, toList(delay(() => map_2((i) => e_1.dataTransfer.files.item(i), rangeDouble(0, 1, e_1.dataTransfer.files.length - 1))))]));
                    }], (elems_7 = [createElement(TextButton, {
                        ComponentState: componentState,
                        Label: t("file_upload.select_file"),
                        OnClick: () => {
                            const element = document.getElementById(fileUploadId);
                            element.click();
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => append(singleton(reactElement("input", {
                        id: fileUploadId,
                        className: join(" ", ["hidden"]),
                        type: "file",
                        multiple: true,
                        onChange: (ev) => {
                            const fileList = ev.target.files;
                            if (!(fileList == null)) {
                                props.Dispatch(new Msg(16, [procedureTemplateStepElement.Id, toList(delay(() => map_2((i_1) => fileList.item(i_1), rangeDouble(0, 1, fileList.length - 1))))]));
                            }
                        },
                    })), delay(() => {
                        let elems_11;
                        return !isEmpty(elementDocuments) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "mt-2"])], (elems_11 = toList(delay(() => map((tupledArg) => {
                            let elems_10, elems_8, elems_9;
                            const index = tupledArg[0] | 0;
                            const docFile = tupledArg[1];
                            return reactElement("div", createObj(ofArray([["className", join(" ", ["rounded-md", "border", "border-border", "p-3"])], (elems_10 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "mb-2"])], (elems_8 = [reactElement("span", {
                                className: join(" ", ["text-sm", "truncate", "font-medium"]),
                                children: docFile.File.name,
                            }), reactElement("button", {
                                className: join(" ", ["text-gray-400", "hover:text-red", "cursor-pointer", "ml-2", "flex-shrink-0"]),
                                onClick: (e_2) => {
                                    e_2.preventDefault();
                                    e_2.stopPropagation();
                                    props.Dispatch(new Msg(17, [procedureTemplateStepElement.Id, index]));
                                },
                                children: "✕",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_9 = [createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.name"),
                                OnChange: (v_3) => {
                                    props.Dispatch(new Msg(18, [procedureTemplateStepElement.Id, index, v_3]));
                                },
                                TestId: "",
                                Value: docFile.Name,
                            }), createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.description"),
                                OnChange: (v_4) => {
                                    props.Dispatch(new Msg(19, [procedureTemplateStepElement.Id, index, v_4]));
                                },
                                TestId: "",
                                Value: docFile.Description,
                            }), Checkbox({
                                ComponentState: componentState,
                                IsChecked: docFile.IsVisibleForUserRole,
                                Label: t("tool.document_visible_for_user_role"),
                                OnCheck: (_arg_16) => {
                                    props.Dispatch(new Msg(20, [procedureTemplateStepElement.Id, index]));
                                },
                                TestId: "",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
                        }, indexed(elementDocuments)))), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))) : empty();
                    }))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_12))]))))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
            }
            case 14: {
                const propertyConfiguration = bind((id) => tryFind((pc) => (PropertyConfigurationId__get_unwrap(pc.Id) === id), props.PropertyConfigurations), procedureTemplateStepElement.PropertyConfigurationId);
                const currentValue = defaultArg(bind((_arg_17) => _arg_17.CustomFieldValue, currentResult), "");
                const dispatchValue = (value_93) => {
                    props.Dispatch(new Msg(9, [procedureTemplateStepElement.Id, value_93]));
                };
                if (propertyConfiguration != null) {
                    const configuration = propertyConfiguration;
                    const displayConfiguration = new PropertyConfiguration(configuration.Id, procedureTemplateStepElement.Label, configuration.Required, configuration.IsDeleted, configuration.Type, configuration.Visibility, configuration.CreatedAt, configuration.UpdatedAt);
                    const propertyId = PropertyConfigurationId__get_unwrap(configuration.Id);
                    const widgetFormState = FormState_$ctor_240AE3F4(ofList(map((tupledArg_1) => {
                        const key_63 = tupledArg_1[0];
                        const value_94 = tupledArg_1[1];
                        if (key_63 === procedureTemplateStepElement.Id) {
                            return [concat("custom-property-", ...propertyId), value_94];
                        }
                        else {
                            return [key_63, value_94];
                        }
                    }, toList_1(props.FormState.Validations)), {
                        Compare: (x, y) => (comparePrimitives(x, y) | 0),
                    }), props.FormState.IsLoading);
                    const currentCustomProperty = (currentValue === "") ? undefined : (new CustomProperty(propertyId, currentValue));
                    const onSetCustomProperties = (properties_27) => {
                        dispatchValue(defaultArg(map_1((_arg_18) => _arg_18.Value, tryFind((p) => (p.Id === propertyId), properties_27)), ""));
                    };
                    const customProperties = defaultArg(map_1(singleton_1, currentCustomProperty), empty_1());
                    const matchValue_4 = configuration.Type;
                    switch (matchValue_4.tag) {
                        case 1:
                            return createElement(TextAreaProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 5:
                            return createElement(BoolProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 4:
                            return createElement(DateProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 7:
                            return createElement(CurrencyProperty, {
                                Currency: (matchValue_5 = props.CustomerConfiguration, (matchValue_5.tag === 1) ? matchValue_5.fields[0].Currency : "eUR"),
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 2:
                            return createElement(EnumProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 3:
                            return createElement(MultiEnumProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        default:
                            return createElement(StringProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                    }
                }
                else {
                    return createElement(Input, {
                        ComponentState: componentState,
                        Label: procedureTemplateStepElement.Label,
                        OnChange: dispatchValue,
                        TestId: "",
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                        Value: currentValue,
                    });
                }
            }
            case 15: {
                const allowedStates = choose(ToolState_TryParse_Z721C83C5, procedureTemplateStepElement.Options);
                const currentValue_1 = bind((_arg_19) => _arg_19.ToolStateChangeValue, currentResult);
                const currentComment_1 = defaultArg(bind((_arg_20) => _arg_20.ToolStateChangeComment, currentResult), "");
                const hasExplicitChoice = defaultArg(map_1((r) => equals(r.Type, new ProcedureTemplateStepElementType(15, [])), currentResult), false);
                const isNoChangeSelected = ((currentValue_1 == null) && hasExplicitChoice) ? true : !hasExplicitChoice;
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_14 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => append(singleton(RadioButton({
                    ComponentState: componentState,
                    Label: t("procedure.tool_state_change.no_change"),
                    OnSelect: (_arg_21) => {
                        props.Dispatch(new Msg(10, [procedureTemplateStepElement.Id, undefined]));
                    },
                    Selected: isNoChangeSelected,
                })), delay(() => append(map((state) => {
                    const isCurrentToolState = equals(props.CurrentToolState, state);
                    return RadioButton({
                        ComponentState: isCurrentToolState ? "disabled" : componentState,
                        Label: t(ToolState__ToI18nString(state)),
                        OnSelect: (_arg_22) => {
                            if (!isCurrentToolState) {
                                props.Dispatch(new Msg(10, [procedureTemplateStepElement.Id, state]));
                            }
                        },
                        Selected: equals(currentValue_1, state),
                    });
                }, allowedStates), delay(() => append((currentValue_1 != null) ? singleton(createElement(TextArea, {
                    ComponentState: componentState,
                    Label: t("general.comment"),
                    OnChange: (value_105) => {
                        props.Dispatch(new Msg(11, [procedureTemplateStepElement.Id, value_105]));
                    },
                    TestId: "tool-state-change-comment",
                    Value: currentComment_1,
                })) : empty(), delay(() => {
                    const matchValue_6 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id);
                    if (matchValue_6 == null) {
                        return empty();
                    }
                    else {
                        const msg_2 = matchValue_6;
                        return singleton(reactElement("p", {
                            className: join(" ", ["mt-1", "text-red", "text-sm"]),
                            children: msg_2,
                        }));
                    }
                })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_14))])])));
            }
            case 16: {
                const storageOptions = map((storage) => ({
                    label: storage.Name,
                    value: unwrapStorageId(storage.Id),
                }), props.Storages);
                const currentStorageId = bind((_arg_23) => _arg_23.StorageTransferStorageId, currentResult);
                const currentStorageSpace = defaultArg(bind((_arg_24) => _arg_24.StorageTransferStorageSpace, currentResult), "");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_15 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), createElement(Select, (Label_20 = t("tool.switch_storage_target"), (Value_9 = bind((storageId) => tryFind((o_1) => (o_1.value === storageId), storageOptions), currentStorageId), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: unwrap(Label_20),
                    NoOptionsMessage: "",
                    OnChange: (option_36) => {
                        props.Dispatch(new Msg(12, [procedureTemplateStepElement.Id, map_1((o) => o.value, option_36)]));
                    },
                    Options: storageOptions,
                    PlaceholderKey: "",
                    TestId: "storage-transfer-target",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: unwrap(Value_9),
                }))), createElement(Input, {
                    ComponentState: componentState,
                    Label: t("tool.storage_space"),
                    OnChange: (value_115) => {
                        props.Dispatch(new Msg(13, [procedureTemplateStepElement.Id, value_115]));
                    },
                    TestId: "storage-transfer-space",
                    Value: currentStorageSpace,
                })], ["children", reactApi.Children.toArray(Array.from(elems_15))])])));
            }
            case 17: {
                const entries = defaultArg(bind((_arg_25) => _arg_25.ReminderCompletionEntries, currentResult), empty_1());
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_18 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => (isEmpty(props.OpenReminders) ? singleton(reactElement("p", {
                    className: join(" ", ["text-sm", "text-gray-400"]),
                    children: t("procedure.reminder_completion.no_open_reminders"),
                })) : map((reminder) => {
                    let elems_17;
                    const entry_1 = tryFind((e_3) => (e_3.ReminderId === reminder.Id), entries);
                    const reminderDate = toString(toLocalTime(reminder.Date), "dd.MM.yyyy");
                    const updateEntry = (updatedEntry) => {
                        props.Dispatch(new Msg(14, [procedureTemplateStepElement.Id, updatedEntry]));
                    };
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_17 = toList(delay(() => append(singleton(Checkbox({
                        ComponentState: componentState,
                        IsChecked: entry_1 != null,
                        Label: concat(reminder.Title, " (", reminderDate, ...")"),
                        OnCheck: (value_126) => {
                            if (value_126) {
                                updateEntry(new ProcedureReminderCompletionEntry(reminder.Id, "", reminder.Interval != null, undefined, false, undefined));
                            }
                            else {
                                props.Dispatch(new Msg(15, [procedureTemplateStepElement.Id, reminder.Id]));
                            }
                        },
                        TestId: "",
                    })), delay(() => {
                        let elems_16;
                        const matchValue_7 = entry_1;
                        if (matchValue_7 == null) {
                            return singleton(defaultOf());
                        }
                        else {
                            const entry_2 = matchValue_7;
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["ml-7", "flex", "flex-col", "gap-2"])], (elems_16 = toList(delay(() => append((reminder.Interval != null) ? append(singleton(Checkbox({
                                ComponentState: componentState,
                                IsChecked: entry_2.CreateNewDate,
                                Label: t("reminder_dialog.plan_next_date"),
                                OnCheck: (value_128) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_2.ReminderId, entry_2.Comment, value_128, entry_2.NextInspectionDate, entry_2.SetLastInspectionDate, entry_2.LastInspectionDate));
                                },
                                TestId: "",
                            })), delay(() => (entry_2.CreateNewDate ? singleton(createElement(DatePicker, {
                                ComponentState: componentState,
                                IsClearable: true,
                                Label: t("tool.next_inspection"),
                                OnChange: (newDate) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_2.ReminderId, entry_2.Comment, entry_2.CreateNewDate, map_1(toISOString, newDate), entry_2.SetLastInspectionDate, entry_2.LastInspectionDate));
                                },
                                TestId: "",
                                Value: unwrap(map_1(parse, entry_2.NextInspectionDate)),
                            })) : empty()))) : empty(), delay(() => append(singleton(Checkbox({
                                ComponentState: componentState,
                                IsChecked: entry_2.SetLastInspectionDate,
                                Label: t("reminder_dialog.set_last_check_field"),
                                OnCheck: (value_129) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_2.ReminderId, entry_2.Comment, entry_2.CreateNewDate, entry_2.NextInspectionDate, value_129, entry_2.LastInspectionDate));
                                },
                                TestId: "",
                            })), delay(() => append(entry_2.SetLastInspectionDate ? singleton(createElement(DatePicker, {
                                ComponentState: componentState,
                                IsClearable: true,
                                Label: t("reminder_dialog.check_date"),
                                OnChange: (newDate_1) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_2.ReminderId, entry_2.Comment, entry_2.CreateNewDate, entry_2.NextInspectionDate, entry_2.SetLastInspectionDate, newDate_1));
                                },
                                TestId: "",
                                Value: unwrap(entry_2.LastInspectionDate),
                            })) : empty(), delay(() => singleton(createElement(TextArea, {
                                ComponentState: componentState,
                                Label: t("general.comment"),
                                OnChange: (value_130) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_2.ReminderId, value_130, entry_2.CreateNewDate, entry_2.NextInspectionDate, entry_2.SetLastInspectionDate, entry_2.LastInspectionDate));
                                },
                                TestId: "",
                                Value: entry_2.Comment,
                            })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_16))])]))));
                        }
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_17))])])));
                }, props.OpenReminders)))))), ["children", reactApi.Children.toArray(Array.from(elems_18))])])));
            }
            case 13: {
                const elementDocuments_1 = defaultArg(map_1((_arg_26) => _arg_26.Files, tryFind((entry_3) => (entry_3.ElementId === procedureTemplateStepElement.Id), props.DocumentUploads)), empty_1());
                const fileUploadId_1 = concat("doc-upload-", ...procedureTemplateStepElement.Id);
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_24 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => {
                    let elems_19;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "justify-center", "items-center", "rounded-lg", "border", "border-dashed", "border-primary", "p-4"])], ["onDragOver", (e_4) => {
                        e_4.preventDefault();
                    }], ["onDrop", (e_5) => {
                        e_5.preventDefault();
                        props.Dispatch(new Msg(21, [procedureTemplateStepElement.Id, toList(delay(() => map_2((i_2) => e_5.dataTransfer.files.item(i_2), rangeDouble(0, 1, e_5.dataTransfer.files.length - 1))))]));
                    }], (elems_19 = [createElement(TextButton, {
                        ComponentState: componentState,
                        Label: t("file_upload.select_file"),
                        OnClick: () => {
                            const element_1 = document.getElementById(fileUploadId_1);
                            element_1.click();
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_19))])])))), delay(() => append(singleton(reactElement("input", {
                        id: fileUploadId_1,
                        className: join(" ", ["hidden"]),
                        type: "file",
                        multiple: true,
                        onChange: (ev_1) => {
                            const fileList_1 = ev_1.target.files;
                            if (!(fileList_1 == null)) {
                                props.Dispatch(new Msg(21, [procedureTemplateStepElement.Id, toList(delay(() => map_2((i_3) => fileList_1.item(i_3), rangeDouble(0, 1, fileList_1.length - 1))))]));
                            }
                        },
                    })), delay(() => {
                        let elems_23;
                        return append(!isEmpty(elementDocuments_1) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "mt-2"])], (elems_23 = toList(delay(() => map((tupledArg_2) => {
                            let elems_22, elems_20, elems_21;
                            const index_1 = tupledArg_2[0] | 0;
                            const docFile_1 = tupledArg_2[1];
                            return reactElement("div", createObj(ofArray([["className", join(" ", ["rounded-md", "border", "border-border", "p-3"])], (elems_22 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "mb-2"])], (elems_20 = [reactElement("span", {
                                className: join(" ", ["text-sm", "truncate", "font-medium"]),
                                children: docFile_1.File.name,
                            }), reactElement("button", {
                                className: join(" ", ["text-gray-400", "hover:text-red", "cursor-pointer", "ml-2", "flex-shrink-0"]),
                                onClick: (e_6) => {
                                    e_6.preventDefault();
                                    e_6.stopPropagation();
                                    props.Dispatch(new Msg(22, [procedureTemplateStepElement.Id, index_1]));
                                },
                                children: "✕",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_20))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_21 = [createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.name"),
                                OnChange: (v_5) => {
                                    props.Dispatch(new Msg(23, [procedureTemplateStepElement.Id, index_1, v_5]));
                                },
                                TestId: "",
                                Value: docFile_1.Name,
                            }), createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.description"),
                                OnChange: (v_6) => {
                                    props.Dispatch(new Msg(24, [procedureTemplateStepElement.Id, index_1, v_6]));
                                },
                                TestId: "",
                                Value: docFile_1.Description,
                            }), Checkbox({
                                ComponentState: componentState,
                                IsChecked: docFile_1.IsVisibleForUserRole,
                                Label: t("tool.document_visible_for_user_role"),
                                OnCheck: (_arg_28) => {
                                    props.Dispatch(new Msg(25, [procedureTemplateStepElement.Id, index_1]));
                                },
                                TestId: "",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_21))])])))], ["children", reactApi.Children.toArray(Array.from(elems_22))])])));
                        }, indexed(elementDocuments_1)))), ["children", reactApi.Children.toArray(Array.from(elems_23))])])))) : empty(), delay(() => {
                            const matchValue_8 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id);
                            if (matchValue_8 == null) {
                                return empty();
                            }
                            else {
                                const msg_3 = matchValue_8;
                                return singleton(reactElement("p", {
                                    className: join(" ", ["mt-1", "text-red", "text-sm"]),
                                    children: msg_3,
                                }));
                            }
                        }));
                    }))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_24))])])));
            }
            default:
                return createElement(Input, (Value = defaultArg(bind((_arg_1) => _arg_1.TextValue, currentResult), ""), {
                    ComponentState: componentState,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_13) => {
                        props.Dispatch(new Msg(0, [procedureTemplateStepElement.Id, value_13]));
                    },
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: Value,
                }));
        }
    }, props.ProcedureTemplateStep.Elements))), ["children", reactApi.Children.toArray(Array.from(elems_25))])]))), reactElement("div", createObj(ofArray([["className", join(" ", [""])], (elems_26 = [createElement(Button, {
        ComponentState: "enabled",
        Label: t("general.save"),
        OnClick: () => {
            props.Dispatch(new Msg(34, []));
        },
        TestId: "back",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems_26))])])))], ["children", reactApi.Children.toArray(Array.from(elems_27))])])))], ["children", reactApi.Children.toArray(Array.from(elems_28))])])));
}

function ProcedureStepDetails(props) {
    let elems_16, elems, Label, elems_15, elems_2, elems_1, elems_14;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "shadow"])], (elems_16 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mt-5", "ml-5"])], (elems = [createElement(TextButton, (Label = t("procedure.back"), {
        ComponentState: "enabled",
        Icon: Arrow_Left_1(),
        Label: Label,
        OnClick: () => {
            props.Dispatch(new Msg(28, [undefined]));
        },
        TestId: "back",
        Variant: "blueButton",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5", "ml-20", "mt-6", "mb-11", "max-w-[30rem]"])], (elems_15 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[2rem_1fr]"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["row-start-1", "col-start-1", "h-4", "w-4", "self-center"])], (elems_1 = [File_Report()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", {
        className: join(" ", ["row-start-1", "col-start-2"]),
        children: props.ProcedureTemplateStep.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3.5"])], (elems_14 = toList(delay(() => map((procedureTemplateStepElement) => {
        let Value_1, elems_3, elems_4, elems_5, elems_6, elems_7, elems_8, elems_9, elems_10, elems_11, elems_12, elems_13, Value;
        const matchValue = procedureTemplateStepElement.Type;
        switch (matchValue.tag) {
            case 2:
                return createElement(Input, (Value_1 = defaultArg(map_1((_arg_2) => ProcedureStepElementResultValue__ResultToString(_arg_2.Value), tryFind((result_1) => (toString_1(result_1.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), ""), {
                    ComponentState: "disabled",
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_15) => {
                    },
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: Value_1,
                }));
            case 1:
                return reactElement("div", {
                    className: join(" ", ["p-3", "bg-gray-100", "rounded", "whitespace-pre-wrap", "break-words"]),
                    children: procedureTemplateStepElement.Label,
                });
            case 7: {
                const hasSignature = exists((result_2) => {
                    if (toString_1(result_2.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id) {
                        if (result_2.Value.tag === 6) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }, props.ProcedureStep.Results);
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_3 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => (hasSignature ? singleton(reactElement("div", {
                    className: join(" ", ["text-green-600"]),
                    children: t("procedure.signature_provided"),
                })) : singleton(reactElement("div", {
                    className: join(" ", ["text-gray-400"]),
                    children: t("procedure.no_signature"),
                }))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
            }
            case 3:
                return createElement(Input, {
                    ComponentState: "disabled",
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_31) => {
                    },
                    TestId: "",
                    Value: defaultArg(map_1((_arg_3) => ProcedureStepElementResultValue__ResultToString(_arg_3.Value), tryFind((result_3) => (toString_1(result_3.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), ""),
                });
            case 4: {
                const boolValue = defaultArg(map_1((r) => {
                    const matchValue_2 = r.Value;
                    if (matchValue_2.tag === 3) {
                        if (matchValue_2.fields[0]) {
                            return t("general.yes");
                        }
                        else {
                            return t("general.no");
                        }
                    }
                    else {
                        return "-";
                    }
                }, tryFind((result_4) => (toString_1(result_4.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), "-");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_4 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: boolValue,
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
            }
            case 5: {
                const dateValue = defaultArg(map_1((_arg_4) => ProcedureStepElementResultValue__ResultToString(_arg_4.Value), tryFind((result_5) => (toString_1(result_5.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), "-");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_5 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: dateValue,
                })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
            }
            case 11:
                return reactElement("div", {
                    className: join(" ", ["p-3", "bg-gray-100", "rounded", "whitespace-pre-wrap", "break-words"]),
                    children: procedureTemplateStepElement.Label,
                });
            case 8:
            case 10: {
                const selectValue = defaultArg(map_1((_arg_5) => ProcedureStepElementResultValue__ResultToString(_arg_5.Value), tryFind((result_6) => (toString_1(result_6.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), "-");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_6 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: selectValue,
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
            }
            case 9: {
                const multiValues = defaultArg(map_1((_arg_6) => ProcedureStepElementResultValue__ResultToString(_arg_6.Value), tryFind((result_7) => (toString_1(result_7.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), "-");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_7 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: multiValues,
                })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
            }
            case 12: {
                const resultData = tryFind((result_8) => (toString_1(result_8.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results);
                const inspectionValue = defaultArg(map_1((_arg_7) => ProcedureStepElementResultValue__ResultToString(_arg_7.Value), resultData), "-");
                const inspectionComment = defaultArg(bind((_arg_8) => _arg_8.Comment, resultData), "");
                let inspectionLabel;
                const matchValue_3 = procedureTemplateStepElement.InspectionTemplateName;
                inspectionLabel = ((matchValue_3 == null) ? procedureTemplateStepElement.Label : concat(procedureTemplateStepElement.Label, " (", matchValue_3, ...")"));
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_8 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: inspectionLabel,
                })), delay(() => append(singleton(reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: inspectionValue,
                })), delay(() => ((inspectionComment !== "") ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-gray-500", "mt-1"]),
                    children: inspectionComment,
                })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
            }
            case 14: {
                const customFieldValue = defaultArg(map_1((_arg_9) => ProcedureStepElementResultValue__ResultToString(_arg_9.Value), tryFind((result_9) => (toString_1(result_9.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), "-");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_9 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: customFieldValue,
                })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
            }
            case 13: {
                const documentCount = defaultArg(map_1((r_1) => (length(r_1.DocumentUrls) | 0), tryFind((result_10) => (toString_1(result_10.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), 0) | 0;
                const documentLabel = t("procedure.document_count");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_10 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), reactElement("div", {
                    className: join(" ", ["text-sm", "text-gray-500"]),
                    children: `${documentCount} ${documentLabel}`,
                })], ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
            }
            case 15: {
                const resultData_2 = tryFind((result_11) => (toString_1(result_11.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results);
                let displayText;
                const matchValue_4 = map_1((r_2) => r_2.Value, resultData_2);
                let matchResult, state;
                if (matchValue_4 != null) {
                    if (matchValue_4.tag === 14) {
                        if (matchValue_4.fields[0] == null) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 0;
                            state = matchValue_4.fields[0];
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
                switch (matchResult) {
                    case 0: {
                        displayText = t(ToolState__ToI18nString(state));
                        break;
                    }
                    case 1: {
                        displayText = t("procedure.tool_state_change.no_change");
                        break;
                    }
                    default:
                        displayText = "-";
                }
                const displayComment = defaultArg(bind((_arg_10) => _arg_10.Comment, resultData_2), "");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_11 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => append(singleton(reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: displayText,
                })), delay(() => ((displayComment !== "") ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-gray-500", "mt-1"]),
                    children: displayComment,
                })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
            }
            case 16: {
                let transferResult;
                const matchValue_5 = map_1((r_3) => r_3.Value, tryFind((result_12) => (toString_1(result_12.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results));
                let matchResult_1, value_114;
                if (matchValue_5 != null) {
                    if (matchValue_5.tag === 15) {
                        matchResult_1 = 0;
                        value_114 = matchValue_5.fields[0];
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        transferResult = value_114;
                        break;
                    }
                    default:
                        transferResult = undefined;
                }
                let displayText_1;
                if (transferResult == null) {
                    displayText_1 = "-";
                }
                else {
                    const result_13 = transferResult;
                    const storageName = defaultArg(map_1((storage_1) => storage_1.Name, tryFind((storage) => (unwrapStorageId(storage.Id) === result_13.StorageId), props.Storages)), result_13.StorageId);
                    displayText_1 = ((result_13.StorageSpace !== "") ? concat(storageName, " (", result_13.StorageSpace, ...")") : storageName);
                }
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_12 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: displayText_1,
                })], ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
            }
            case 17: {
                let completedCount;
                const matchValue_6 = map_1((r_4) => r_4.Value, tryFind((result_14) => (toString_1(result_14.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results));
                let matchResult_2, ids;
                if (matchValue_6 != null) {
                    if (matchValue_6.tag === 16) {
                        matchResult_2 = 0;
                        ids = matchValue_6.fields[0];
                    }
                    else {
                        matchResult_2 = 1;
                    }
                }
                else {
                    matchResult_2 = 1;
                }
                switch (matchResult_2) {
                    case 0: {
                        completedCount = length(ids);
                        break;
                    }
                    default:
                        completedCount = 0;
                }
                const completedLabel = t("procedure.reminder_completion.completed_label");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_13 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), reactElement("div", {
                    className: join(" ", ["text-lg"]),
                    children: `${completedCount} ${completedLabel}`,
                })], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
            }
            case 6:
                return reactElement("div", {
                    className: join(" ", ["text-gray-400", "italic"]),
                    children: "-",
                });
            default:
                return createElement(Input, (Value = defaultArg(map_1((_arg_1) => ProcedureStepElementResultValue__ResultToString(_arg_1.Value), tryFind((result) => (toString_1(result.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ProcedureStep.Results)), ""), {
                    ComponentState: "disabled",
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_13) => {
                    },
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: Value,
                }));
        }
    }, props.ProcedureTemplateStep.Elements))), ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])));
}

export function ProcedureStepOverview(props) {
    let elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("grid"), delay(() => append(singleton("grid-cols-[3.5rem_1fr]"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("rounded"), delay(() => append(singleton("shadow"), delay(() => append(singleton("cursor-pointer"), delay(() => (props.IsCompleted ? append(singleton("border-l-4"), delay(() => singleton("border-icon-green"))) : (props.HasValidationError ? append(singleton("border-l-4"), delay(() => singleton("border-red"))) : empty())))))))))))))))))], ["onClick", (e) => {
        e.preventDefault();
        props.Dispatch(new Msg(28, [new ProcedureTemplateStepId(parse_1(props.ProcedureTemplateStep.Id))]));
    }], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("row-start-1"), delay(() => append(singleton("col-start-1"), delay(() => append(singleton("m-5"), delay(() => append(singleton("h-5"), delay(() => append(singleton("w-5"), delay(() => (props.IsCompleted ? singleton("text-icon-green") : empty()))))))))))))))], (elems = toList(delay(() => {
        if (props.IsCompleted) {
            Check_Circle();
            return empty();
        }
        else {
            File_Report();
            return empty();
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", {
        className: join(" ", ["row-start-1", "col-start-2", "mt-5", "text-night-blue", "font-medium"]),
        children: props.ProcedureTemplateStep.Name,
    }), reactElement("div", {
        className: join(" ", ["row-start-2", "col-start-2", "mb-4", "text-cold-grey", "text-sm", "whitespace-pre-wrap", "break-words"]),
        children: props.ProcedureTemplateStep.Description,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ProcedureForm(props) {
    let elems_7;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsCancelConfirmationOpen = patternInput_1[1];
    const procedureState = props.ProcedureForm.Procedure.State;
    const isReadOnly = (procedureState.tag === 1) ? true : ((procedureState.tag === 2) ? true : (procedureState.tag === 3));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "gap-2", "mb-3", "bg-light-grey-01", "rounded", "px-12", "py-9", "grow", "overflow-y-auto"])], (elems_7 = toList(delay(() => {
        let elems_2, elems_1;
        const matchValue = props.SelectedTemplateStep;
        if (matchValue == null) {
            return append(!isEmpty(props.ProcedureForm.InformationFieldValues) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "shadow", "p-6", "mb-4"])], (elems_2 = [reactElement("div", {
                className: join(" ", ["font-bold", "mb-3"]),
                children: t("procedure.information_fields.title"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-3"])], (elems_1 = toList(delay(() => map((fieldValue) => {
                let elems;
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [reactElement("span", {
                    className: join(" ", ["text-xs", "text-gray-500"]),
                    children: t(fieldValue.Label),
                }), reactElement("span", {
                    className: join(" ", ["text-sm"]),
                    children: (fieldValue.Value !== "") ? fieldValue.Value : "-",
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
            }, props.ProcedureForm.InformationFieldValues))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty(), delay(() => {
                let matchValue_2, elems_4, elems_5, elems_3;
                return append((matchValue_2 = procedureState, (matchValue_2.tag === 2) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [createElement(InformationAlert, {
                    Label: t("procedure.status_completed_failed"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : ((matchValue_2.tag === 3) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_5 = [createElement(InformationAlert, {
                    Label: t("procedure.status_cancelled"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : ((matchValue_2.tag === 0) ? (empty()) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_3 = [createElement(InformationAlert, {
                    Label: t("procedure.status_completed_successful"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))))), delay(() => {
                    const completedTemplateStepIds = ofList_1(map((s) => toString_1(s.ProcedureTemplateStepId), props.ProcedureForm.Procedure.Steps), {
                        Compare: (x, y) => (comparePrimitives(x, y) | 0),
                    });
                    return append(map((step_2) => {
                        const isCompleted = contains(step_2.Id, completedTemplateStepIds);
                        return createElement(ProcedureStepOverview, {
                            Dispatch: props.Dispatch,
                            HasValidationError: containsKey(step_2.Id, props.FormState.Validations),
                            IsCompleted: isCompleted,
                            ProcedureTemplateStep: step_2,
                        });
                    }, props.ProcedureForm.ProcedureTemplate.Steps), delay(() => {
                        let elems_6, Title;
                        if (!isReadOnly) {
                            const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-end", "gap-5", "mt-6"])], (elems_6 = [createElement(Button, {
                                ComponentState: componentState,
                                Label: t("procedure.cancel_procedure"),
                                OnClick: () => {
                                    setIsCancelConfirmationOpen(true);
                                },
                                TestId: "cancel-procedure",
                                Variant: "secondary",
                            }), createElement(Button, {
                                ComponentState: componentState,
                                Label: t("procedure.complete_procedure"),
                                OnClick: () => {
                                    props.Dispatch(new Msg(46, []));
                                },
                                TestId: "complete-procedure",
                                Variant: "primary",
                            }), createElement(ConfirmationDialogWithClasses, (Title = t("procedure.cancel_procedure"), {
                                Classes: singleton_1("z-[1100]"),
                                Description: t("procedure.cancel_confirmation"),
                                FormState: props.FormState,
                                IsOpen: patternInput_1[0],
                                OnClose: () => {
                                    setIsCancelConfirmationOpen(false);
                                },
                                OnConfirm: () => {
                                    setIsCancelConfirmationOpen(false);
                                    props.Dispatch(new Msg(48, []));
                                },
                                Title: Title,
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                        }
                        else {
                            return empty();
                        }
                    }));
                }));
            }));
        }
        else {
            const templateStepId = matchValue;
            const procedureTemplateStep = find((step) => equals(new ProcedureTemplateStepId(parse_1(step.Id)), templateStepId), props.ProcedureForm.ProcedureTemplate.Steps);
            const existingProcedureStep = tryFind((step_1) => equals(step_1.ProcedureTemplateStepId, new ProcedureTemplateStepId(parse_1(procedureTemplateStep.Id))), props.ProcedureForm.Procedure.Steps);
            let matchResult, procedureStep;
            if (existingProcedureStep != null) {
                if (isReadOnly) {
                    matchResult = 0;
                    procedureStep = existingProcedureStep;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton(createElement(ProcedureStepDetails, {
                        Dispatch: props.Dispatch,
                        FormState: props.FormState,
                        ProcedureStep: procedureStep,
                        ProcedureTemplateStep: procedureTemplateStep,
                        Storages: props.Storages,
                    }));
                default:
                    return singleton(createElement(ProcedureStepForm, {
                        CurrentToolState: unwrap(props.ProcedureForm.CurrentToolState),
                        CustomerConfiguration: props.CustomerConfiguration,
                        Dispatch: props.Dispatch,
                        DocumentUploads: props.DocumentUploads,
                        FormState: props.FormState,
                        InspectionDocuments: props.InspectionDocuments,
                        OpenReminders: props.ProcedureForm.OpenReminders,
                        ProcedureTemplateStep: procedureTemplateStep,
                        PropertyConfigurations: props.PropertyConfigurations,
                        StepFiles: props.StepFiles,
                        Storages: props.Storages,
                        WriteProcedureStepDto: props.WriteProcedureStepDto,
                    }));
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function View(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.ProcedureId, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProcedureForm;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "normal",
        });
    }
    else {
        return createElement(ProcedureForm, {
            CustomerConfiguration: state_1.CustomerConfiguration,
            Dispatch: patternInput[1],
            DocumentUploads: state_1.DocumentUploads,
            FormState: state_1.FormState,
            InspectionDocuments: state_1.InspectionDocuments,
            ProcedureForm: matchValue.fields[0],
            PropertyConfigurations: state_1.PropertyConfigurations,
            SelectedTemplateStep: unwrap(state_1.SelectedTemplateStep),
            StepFiles: state_1.StepFiles,
            Storages: state_1.Storages,
            WriteProcedureStepDto: state_1.WriteProcedureStepDto,
        });
    }
}

export function OpenProcedureModal(props) {
    let elems, matchValue;
    const patternInput = useTranslation();
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.ProcedureId, undefined);
    const state_1 = patternInput_1[0];
    const dependencies_1 = [state_1.IsProcedureCompleted];
    reactApi.useEffect(() => {
        if (state_1.IsProcedureCompleted) {
            props.OnSuccessCallback();
        }
    }, dependencies_1);
    const dependencies_3 = [state_1.IsProcedureCancelled];
    reactApi.useEffect(() => {
        if (state_1.IsProcedureCancelled) {
            props.OnCancelCallback();
        }
    }, dependencies_3);
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = state_1.ProcedureForm, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : createElement(ProcedureForm, {
            CustomerConfiguration: state_1.CustomerConfiguration,
            Dispatch: patternInput_1[1],
            DocumentUploads: state_1.DocumentUploads,
            FormState: state_1.FormState,
            InspectionDocuments: state_1.InspectionDocuments,
            ProcedureForm: matchValue.fields[0],
            PropertyConfigurations: state_1.PropertyConfigurations,
            SelectedTemplateStep: unwrap(state_1.SelectedTemplateStep),
            StepFiles: state_1.StepFiles,
            Storages: state_1.Storages,
            WriteProcedureStepDto: state_1.WriteProcedureStepDto,
        })),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        ZIndex: 1000,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

